import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import Portfolio from "./sections/Portfolio";
import CustomerReviews from "./sections/CustomerReviews";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <Portfolio />
      <CustomerReviews />
      <GetInTouch />
      <Footer />
    </div>;
}